export default "__VITE_PUBLIC_ASSET__d26b18f8__"